import React, { useState } from 'react';
import AdminNav from '../components/AdminNav';

const s = {
  page: { minHeight: '100vh', background: '#f8f8f6' },
  content: { maxWidth: '520px', margin: '0 auto', padding: '40px 16px' },
  heading: { fontSize: '22px', fontWeight: '700', color: '#111', marginBottom: '24px' },
  card: {
    background: '#fff', borderRadius: '10px',
    boxShadow: '0 1px 8px rgba(0,0,0,0.07)', padding: '28px',
  },
  cardTitle: { fontSize: '15px', fontWeight: '700', color: '#111', marginBottom: '18px' },
  label: { display: 'block', fontSize: '13px', fontWeight: '600', color: '#444', marginBottom: '5px' },
  input: {
    width: '100%', padding: '9px 12px', marginBottom: '14px',
    border: '1.5px solid #ddd', borderRadius: '7px',
    fontSize: '14px', outline: 'none', boxSizing: 'border-box',
  },
  btn: {
    padding: '10px 20px', background: '#111', color: '#fff',
    border: 'none', borderRadius: '8px', fontSize: '14px',
    fontWeight: '600', cursor: 'pointer',
  },
  hint: { fontSize: '12px', color: '#888', marginBottom: '14px', marginTop: '-8px' },
  success: { color: '#15803d', fontSize: '13px', marginTop: '10px' },
  err: { color: '#dc2626', fontSize: '13px', marginTop: '10px' },
};

export default function Settings() {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    if (next !== confirm) { setError('New passwords do not match.'); return; }
    setSaving(true);
    try {
      const res = await fetch('/api/auth/change-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ currentPassword: current, newPassword: next }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Failed to update password.'); return; }
      setSuccess('Password updated successfully.');
      setCurrent(''); setNext(''); setConfirm('');
    } catch {
      setError('Network error.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={s.page}>
      <AdminNav />
      <div style={s.content}>
        <div style={s.heading}>Settings</div>
        <div style={s.card}>
          <div style={s.cardTitle}>Change Password</div>
          <form onSubmit={handleSubmit}>
            <label style={s.label}>Current Password</label>
            <input style={s.input} type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required />
            <label style={s.label}>New Password</label>
            <input style={s.input} type="password" value={next} onChange={(e) => setNext(e.target.value)} required minLength={8} />
            <div style={s.hint}>Min 8 characters, must include uppercase, lowercase, and a number.</div>
            <label style={s.label}>Confirm New Password</label>
            <input style={s.input} type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
            <button type="submit" style={s.btn} disabled={saving}>{saving ? 'Saving…' : 'Update Password'}</button>
            {error && <div style={s.err}>{error}</div>}
            {success && <div style={s.success}>{success}</div>}
          </form>
        </div>
      </div>
    </div>
  );
}
